import './profile-program.scss';
import {ProgramAdminCardProps} from "../../../../../components/UI/Cards/Plar/ProgramAdminCard";
import {useEffect, useState} from "react";
import {PlarCardType} from "../../../../../components/UI/Cards/Plar/PlarCard";
import StatusChiclet from "../../../../../components/UI/Chiclets/StatusChiclet/StatusChiclet";
import PaymentChiclet from "../../../../../components/UI/Chiclets/PaymentChiclet/PaymentChiclet";
import ProgressChiclet from "../../../../../components/UI/Chiclets/ProgressChiclet/ProgressChiclet";
import {cardTypeToChicletType} from "../../../../../components/UI/Cards/Plar/ProgramAdminCard/ProgramAdminCardStatus";
import CloseIcon from "../../../../../assets/icons/UI/select/arrow-up.svg";
import OpenIcon from "../../../../../assets/icons/UI/select/arrow-down.svg";
import ProfileCourses from "./ProfileCourses";

const ApplicantProfileProgram = (props: ProgramAdminCardProps) => {
  const {
    type = PlarCardType.Not_started,
    title,
    chicletText,
    num_cpl_eligible_recommendations,
    num_paid_recommendations,
    expandedByDefault,
    programId,
    courses
  } = props;

  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (expandedByDefault) {
      setExpanded(true);
    }
  }, [expandedByDefault, setExpanded])

  return <div className={'profile-program'}>
    <div className={'profile-program-main'}>
      <span className={'profile-program-title'}>
        {title}
      </span>
      {
        chicletText
          ? <ProgressChiclet type={cardTypeToChicletType[type]} text={chicletText}/>
          : null
      }
      {
        num_cpl_eligible_recommendations > 0
          ? <StatusChiclet
            text={'Contains CPL Eligible Courses'}
          />
          : null
      }
      {
        num_paid_recommendations > 0
          ? <PaymentChiclet
            text={`${num_paid_recommendations} ${num_paid_recommendations > 1 ? 'courses' : 'course'} paid`}/>
          : null
      }

      <div className={'profile-program-line'}/>

      <img
        src={expanded ? CloseIcon : OpenIcon}
        alt={expanded ? 'close-menu' : 'open-menu'}
        className={'sorting-active-open-btn'}
        onClick={() => setExpanded(!expanded)}
      />
    </div>

    {expanded
      ? <ProfileCourses
        programId={programId ? programId : 0}
        courses={courses}
      />
      : null
    }
  </div>
}

export default ApplicantProfileProgram;